import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { SearchIcon } from '@primer/octicons-react';
import { LTActionMenu, LTButton, LTInputBox, LTText } from '@lambdatestincprivate/lt-components';
import { usePackState } from '../../data/pack-store';
import { acBucket, aspectNames } from '../../model/coverage';
import { CoverageTabIcon } from '../Tabs/RunTabIcons';
import { LoadingJourney } from '../states/LoadingJourney';
import statesStyles from '../states/states.module.css';
import { usecaseMatches, usecaseStatusMatches } from './search';
import { onCoverageFocus, peekCoverageFocus } from './coverage-focus';
import { ContextDrawer } from './ContextDrawer';
import { UsecaseCard } from './UsecaseCard';
import styles from './coverage.module.css';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var BUCKET_LABELS = {
  verified: 'verified',
  uncovered: 'uncovered / failing',
  weak: 'weak / stale'
};
var BUCKET_COLORS = {
  verified: 'var(--lt-text-success)',
  uncovered: 'var(--lt-text-error)',
  weak: 'var(--lt-text-warning)'
};
function SummaryBand(_ref) {
  var _a$summary$coveragePc;
  var doc = _ref.doc,
    aspect = _ref.aspect;
  var a = doc.aspects[aspect];
  // Bucket counts are presentation over sealed per-AC facts (README §1);
  // the headline numbers come from the rollup verbatim.
  var buckets = useMemo(function () {
    var counts = {
      verified: 0,
      uncovered: 0,
      weak: 0
    };
    if (!a) return counts;
    var _iterator = _createForOfIteratorHelper(doc.usecases),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var uc = _step.value;
        var _iterator2 = _createForOfIteratorHelper(uc.acceptanceCriteria),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ac = _step2.value;
            counts[acBucket(ac, a.acs)] += 1;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return counts;
  }, [doc, a]);
  if (!a) return null;
  var total = buckets.verified + buckets.uncovered + buckets.weak;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.scoreCard,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.scoreRow,
      children: [/*#__PURE__*/_jsxs("span", {
        className: styles.scorePct,
        children: [(_a$summary$coveragePc = a.summary.coveragePct) !== null && _a$summary$coveragePc !== void 0 ? _a$summary$coveragePc : '—', "%"]
      }), a.summary.acsVerified && /*#__PURE__*/_jsxs("span", {
        className: styles.scoreSub,
        children: [a.summary.acsVerified, " ACs verified"]
      })]
    }), total > 0 && /*#__PURE__*/_jsx("div", {
      className: styles.segBar,
      role: "img",
      "aria-label": "".concat(buckets.verified, " verified, ").concat(buckets.uncovered, " uncovered or failing, ").concat(buckets.weak, " weak or stale"),
      children: Object.keys(buckets).map(function (b) {
        return buckets[b] > 0 && /*#__PURE__*/_jsx("div", {
          className: b === 'verified' ? styles.segVerified : b === 'uncovered' ? styles.segUncovered : styles.segWeak,
          style: {
            flex: buckets[b]
          }
        }, b);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.legend,
      children: Object.keys(buckets).map(function (b) {
        return /*#__PURE__*/_jsxs("span", {
          className: styles.legendItem,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.legendDot,
            style: {
              background: BUCKET_COLORS[b]
            }
          }), /*#__PURE__*/_jsxs("span", {
            className: styles.legendText,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.legendCount,
              children: buckets[b]
            }), BUCKET_LABELS[b]]
          })]
        }, b);
      })
    })]
  });
}
var SHOW_ASPECT_TOGGLE = false;
function AspectConfigPopover(_ref2) {
  var config = _ref2.config;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/_jsxs("span", {
    className: styles.configPopWrap,
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      className: styles.configBtn,
      "aria-expanded": open,
      "aria-label": "Show the scoring config that produced these numbers",
      onClick: function onClick() {
        return setOpen(function (v) {
          return !v;
        });
      },
      children: "i"
    }), open && /*#__PURE__*/_jsxs("div", {
      className: styles.configPop,
      role: "dialog",
      "aria-label": "Aspect config",
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.configTitle,
        children: "Sealed scoring config \u2014 numbers were computed with these knobs at pack-finalize time."
      }), Object.entries(config).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return /*#__PURE__*/_jsxs("div", {
          className: styles.configRow,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.configKey,
            children: k
          }), /*#__PURE__*/_jsx("span", {
            className: styles.configVal,
            children: JSON.stringify(v)
          })]
        }, k);
      })]
    })]
  });
}

/**
 * The Coverage tab — a pure render of coverage/usecases.yaml. Every
 * number/status on this page is a sealed fact from the pack's rollup;
 * the aspect toggle switches WHICH precomputed column is read, nothing
 * is recomputed (README rule zero).
 */
export function CoverageTab() {
  var _ref5;
  var coverage = usePackState(function (s) {
    return s.coverage;
  });
  var phase = usePackState(function (s) {
    return s.coveragePhase;
  });
  var runTitle = usePackState(function (s) {
    var _s$header$title, _s$header;
    return (_s$header$title = (_s$header = s.header) === null || _s$header === void 0 ? void 0 : _s$header.title) !== null && _s$header$title !== void 0 ? _s$header$title : null;
  });
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    query = _useState4[0],
    setQuery = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    statusFilter = _useState6[0],
    setStatusFilter = _useState6[1];
  var names = useMemo(function () {
    return coverage ? aspectNames(coverage) : [];
  }, [coverage]);
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    aspect = _useState8[0],
    setAspect = _useState8[1];
  var active = (_ref5 = aspect !== null && aspect !== void 0 ? aspect : names[0]) !== null && _ref5 !== void 0 ? _ref5 : null;
  var contextRef = useRef(null);
  var gapsRef = useRef(null);
  var _useState9 = useState(peekCoverageFocus),
    _useState0 = _slicedToArray(_useState9, 2),
    focus = _useState0[0],
    setFocus = _useState0[1];

  // Palette navigation: consume pending focus + subscribe for later ones.
  useEffect(function () {
    return onCoverageFocus(function () {
      return setFocus(peekCoverageFocus());
    });
  }, []);
  useEffect(function () {
    if (!focus) return undefined;
    if (focus.kind === 'usecase') {
      // The target card must be visible — drop any active filters.
      setQuery('');
      setStatusFilter(null);
      return undefined;
    }
    if (focus.kind === 'context') {
      var _contextRef$current;
      (_contextRef$current = contextRef.current) === null || _contextRef$current === void 0 || _contextRef$current.openDrawer();
      return undefined;
    }
    var raf = requestAnimationFrame(function () {
      var _gapsRef$current;
      return (_gapsRef$current = gapsRef.current) === null || _gapsRef$current === void 0 ? void 0 : _gapsRef$current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
    return function () {
      return cancelAnimationFrame(raf);
    };
  }, [focus]);
  if (phase === 'loading') {
    return /*#__PURE__*/_jsx(LoadingJourney, {
      stage: "Reading coverage\u2026",
      variant: "pane"
    });
  }
  if (!coverage || !active) {
    return /*#__PURE__*/_jsx("div", {
      className: statesStyles.wrap,
      children: /*#__PURE__*/_jsxs("div", {
        className: statesStyles.emptyTab,
        children: [/*#__PURE__*/_jsx(CoverageTabIcon, {}), /*#__PURE__*/_jsx(LTText, {
          text: "No coverage in this evidence pack",
          variant: LTText.TextVariant.SUBHEADER_BOLD
        }), /*#__PURE__*/_jsx(LTText, {
          text: "This pack was sealed before coverage shipped \u2014 newer runs carry their business use-cases, acceptance criteria and verification rollup here.",
          variant: LTText.TextVariant.SUBHEADER_REGULAR,
          color: "var(--lt-text-secondary)"
        })]
      })
    });
  }
  var aspectVM = coverage.aspects[active];
  var shown = coverage.usecases.filter(function (uc) {
    var _aspectVM$usecases$uc;
    return usecaseMatches(uc, query) && usecaseStatusMatches(aspectVM === null || aspectVM === void 0 || (_aspectVM$usecases$uc = aspectVM.usecases[uc.id]) === null || _aspectVM$usecases$uc === void 0 ? void 0 : _aspectVM$usecases$uc.status, statusFilter);
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles.page,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.pageHead,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.pageTitle,
          children: runTitle !== null && runTitle !== void 0 ? runTitle : 'Coverage'
        }), SHOW_ASPECT_TOGGLE && names.length > 0 && /*#__PURE__*/_jsxs("span", {
          className: styles.aspectToggle,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.aspectGroup,
            role: "group",
            "aria-label": "Scoring aspect",
            children: names.map(function (name) {
              return /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "".concat(styles.aspectBtn, " ").concat(name === active ? styles.aspectBtnActive : ''),
                "aria-pressed": name === active,
                onClick: function onClick() {
                  return setAspect(name);
                },
                children: name
              }, name);
            })
          }), aspectVM && /*#__PURE__*/_jsx(AspectConfigPopover, {
            config: aspectVM.config
          })]
        })]
      }), /*#__PURE__*/_jsx(SummaryBand, {
        doc: coverage,
        aspect: active
      }), /*#__PURE__*/_jsx("span", {
        className: styles.sectionTitle,
        children: "Business Use-cases"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.filterRow,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.filterSearch,
          children: /*#__PURE__*/_jsx(LTInputBox, {
            inputOnly: true,
            size: "medium",
            placeholder: "Find a business use-case...",
            leadingIcon: SearchIcon,
            value: query
            // This lib version calls onChange(value, event) — value first.
            ,
            onChange: function onChange(value) {
              return setQuery(value);
            }
            // The lib's clear button only resets its internal text — it
            // never fires onChange; sync our state through it.
            ,
            trailingAction: function trailingAction() {
              return setQuery('');
            },
            "aria-label": "Find a business use-case"
          })
        }), /*#__PURE__*/_jsx(LTActionMenu, {
          buttonLabel: "Status",
          anchorButtonSize: "medium"
          // The overlay portals outside the viewer root — restate the font
          // (same portal-font rule as the RCA drawer / palette overlays).
          ,
          overlayStyle: {
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif"
          },
          options: [{
            title: '',
            list: [{
              key: null,
              name: 'All'
            }, {
              key: 'covered',
              name: 'Covered'
            }, {
              key: 'partial',
              name: 'Partial'
            }, {
              key: 'uncovered',
              name: 'Uncovered'
            }].map(function (opt) {
              var _opt$key;
              return {
                id: (_opt$key = opt.key) !== null && _opt$key !== void 0 ? _opt$key : 'all',
                name: opt.name,
                isSelected: statusFilter === opt.key,
                onClickHandler: function onClickHandler() {
                  return setStatusFilter(opt.key);
                }
              };
            })
          }]
        }), /*#__PURE__*/_jsx(LTButton, {
          variant: LTButton.Variant.DEFAULT,
          size: LTButton.Size.MEDIUM,
          onClick: function onClick() {
            var _contextRef$current2;
            return (_contextRef$current2 = contextRef.current) === null || _contextRef$current2 === void 0 ? void 0 : _contextRef$current2.openDrawer();
          },
          children: "Context"
        })]
      }), shown.length === 0 ? /*#__PURE__*/_jsx(LTText, {
        text: "No use-cases match.",
        variant: LTText.TextVariant.SUBHEADER_REGULAR,
        color: "var(--lt-text-secondary)"
      }) : shown.map(function (uc) {
        return aspectVM ? /*#__PURE__*/_jsx(UsecaseCard, {
          uc: uc,
          aspect: aspectVM,
          focus: (focus === null || focus === void 0 ? void 0 : focus.kind) === 'usecase' && focus.ucId === uc.id ? focus : undefined
        }, uc.id) : null;
      }), coverage.gaps.length > 0 && /*#__PURE__*/_jsxs("div", {
        ref: gapsRef,
        className: styles.gapsBlock,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.sectionTitle,
          children: "Gaps"
        }), coverage.gaps.map(function (gap) {
          var _gap$question;
          return /*#__PURE__*/_jsxs("div", {
            className: styles.gapRow,
            children: [gap.risk && /*#__PURE__*/_jsx("span", {
              className: "".concat(styles.riskChip, " ").concat(gap.risk === 'high' ? styles.riskHigh : styles.riskMed),
              children: gap.risk
            }), /*#__PURE__*/_jsx("span", {
              className: styles.gapQuestion,
              children: (_gap$question = gap.question) !== null && _gap$question !== void 0 ? _gap$question : gap.ref
            }), gap.kind && /*#__PURE__*/_jsx("span", {
              className: styles.gapKind,
              children: gap.kind
            })]
          }, gap.ref);
        })]
      })]
    }), /*#__PURE__*/_jsx(ContextDrawer, {
      ref: contextRef,
      coverage: coverage
    })]
  });
}